import React, { useEffect } from 'react'
import Login from './components/Pages/Login'
import Navbar from './components/Navbar/Navbar'
import { Navigate, Route, Routes } from 'react-router-dom'
import Dashboard from './components/Pages/Dashboard'
import Analytics from './components/Pages/Analytics'
import Register from './components/Pages/Register'
import { AuthProvider, useAuth } from './context/AuthContext'
import Recurring from './components/Pages/Recurring'
import Home from './components/Pages/Home'
import Recomandations from './components/Pages/Recomandations'



const App = () => {

    useEffect(() => {
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "sxk0pg2hh9");
    }, []);

    const ProtectedRoute = ({ children }) => {
        const { user, loading } = useAuth()
        if (loading) return <p>Loading...</p>
        return user ? children : <Navigate to="/" />
    }

    const PublicRoute = ({ children }) => {
        const { user, loading } = useAuth()
        if (loading) return <p>Loading...</p>
        return user ? <Navigate to="/dashboard" /> : children
    }



    return (
        <>

            <AuthProvider>
                <Navbar />
                <Routes>
                    <Route path='/' element={<PublicRoute><Home /></PublicRoute>} />
                    <Route path='/login' element={<PublicRoute><Login /></PublicRoute>} />
                    <Route path='/register' element={<PublicRoute><Register /></PublicRoute>} />
                    <Route path='/dashboard' element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>} />
                    <Route path='/analytics' element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                    <Route path='/recurring' element={<ProtectedRoute><Recurring /></ProtectedRoute>} />
                    <Route path='/recommendations' element={<ProtectedRoute><Recomandations /></ProtectedRoute>} />
                </Routes>
            </AuthProvider>


        </>

    )
}

export default App